//Creates new heatblock and adds to array of heatblocks
export const createHeatBlock = (data) => {
    //data = {id, solution}
    return { type: "CREATE_HEAT_BLOCK", payload: data}
}

// ---Heat Block ----------------------------:
export const toggleHeatBlockStart = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_HEAT_BLOCK_ACTIVE", payload: data}
}
export const incHeatBlockTime = (data) => {
    //data = {cathodeConnected}
    return { type: "INC_HEAT_BLOCK_TIME", payload: data}
}
export const decHeatBlockTime = (data) => {
    //data = {cathodeConnected}
    return { type: "DEC_HEAT_BLOCK_TIME", payload: data}
}
export const countDownHeatBlockTime = (data) => {
    //data = {cathodeConnected}
    return { type: "COUNT_DOWN_HEAT_BLOCK_TIME", payload: data}
}
export const resetHeatBlockTime = (data) => {
    //data = {cathodeConnected}
    return { type: "RESET_HEAT_BLOCK_TIME", payload: data}
}
export const incHeatBlockTemp = (data) => {
    //data = {cathodeConnected}
    return { type: "INC_HEAT_BLOCK_TEMP", payload: data}
}
export const decHeatBlockTemp = (data) => {
    //data = {cathodeConnected}
    return { type: "DEC_HEAT_BLOCK_TEMP", payload: data}
}
export const addTubeToHeatBlock = (data) => {
    //data = {cathodeConnected}
    return { type: "ADD_TUBE_TO_HEAT_BLOCK", payload: data}
}
export const removeTubeFromHeatBlock = (data) => {
    //data = {cathodeConnected}
    return { type: "REMOVE_TUBE_FROM_HEAT_BLOCK", payload: data}
}
